import { useContext } from 'react';
import { CrumbContext } from './CrumbContextContext';

export function useCrumb() {
  const context = useContext(CrumbContext);
  if (!context) throw new Error('useCrumb must be used within CrumbProvider');
  return context;
}
